/* ============================================================
   HEIRBLOOM FLORAL — theme.js
   Global interactions: mobile nav, cart count, scroll reveal,
   sticky ATC observer, testimonial + product carousels.
   Vanilla JS, no dependencies.
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Mobile navigation drawer ---------- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const navOverlay = document.querySelector('[data-nav-overlay]');
  const navClose = document.querySelector('[data-mobile-nav-close]');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    navOverlay && navOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    mobileNav.setAttribute('aria-hidden', 'false');
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    navOverlay && navOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    mobileNav.setAttribute('aria-hidden', 'true');
  }
  menuToggle && menuToggle.addEventListener('click', openNav);
  navClose && navClose.addEventListener('click', closeNav);
  navOverlay && navOverlay.addEventListener('click', closeNav);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });

  /* ---------- Scroll reveal (IntersectionObserver) ---------- */
  const reveals = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Live cart count refresh ---------- */
  window.updateCartCount = function () {
    fetch(window.HeirbloomRoutes.cart_url + '.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  };

  /* ---------- Simple horizontal carousel (products / testimonials) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
    const track = carousel.querySelector('[data-carousel-track]');
    const prev = carousel.querySelector('[data-carousel-prev]');
    const next = carousel.querySelector('[data-carousel-next]');
    if (!track) return;
    function step() { return track.querySelector('*') ? track.querySelector('*').offsetWidth + 24 : 300; }
    prev && prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next && next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  });

  /* ---------- Sticky mobile add-to-cart visibility ---------- */
  const stickyAtc = document.querySelector('[data-sticky-atc]');
  const atcAnchor = document.querySelector('[data-atc-anchor]');
  if (stickyAtc && atcAnchor && 'IntersectionObserver' in window) {
    const atcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    atcIO.observe(atcAnchor);
  }

  /* ---------- Character counters (card messages) ---------- */
  document.querySelectorAll('[data-char-count]').forEach(function (field) {
    const max = field.getAttribute('maxlength');
    const counter = document.querySelector('[data-char-count-for="' + field.id + '"]');
    if (!counter) return;
    function render() { counter.textContent = (field.value.length) + ' / ' + max; }
    field.addEventListener('input', render);
    render();
  });

  /* ---------- Set delivery date picker minimum to today ---------- */
  document.querySelectorAll('[data-delivery-date]').forEach(function (input) {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    input.min = yyyy + '-' + mm + '-' + dd;
  });
})();
